import React, { Component, Fragment } from "react";
import { debounce } from "lodash";
import { Link } from "react-router-dom";
import queryString from "query-string";
import swal from "sweetalert";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ParticipantsActions,
  Selectors as ParticipantsSelectors
} from "store/ducks/participants";

import {
  Page,
  Panel,
  Button,
  Icon,
  Loading,
  Pagination,
  Form
} from "components";

class List extends Component {
  state = {
    query: ""
  };

  constructor(props) {
    super(props);

    this.handleSearch = debounce(props.getParticipantsRequest, 300);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    this.props.getParticipantsRequest(params.page);
  }

  componentDidUpdate(oldProps) {
    const { location } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      this.props.getParticipantsRequest(
        queryString.parse(location.search).page
      );
    }
  }

  handleChangeQuery = e => {
    const { value } = e.target;

    this.setState({ query: value });
    this.handleSearch(1, value);
  };

  handleDelete = async id => {
    const confirm = await swal({
      title: "Deseja remover?",
      text: "Tem certeza de que deseja remover este participante?",
      type: "info",
      buttons: {
        cancel: "Não",
        confirm: {
          text: "Sim"
        }
      }
    });

    if (confirm) {
      this.props.deleteParticipantRequest(id);
    }
  };

  render() {
    const { participants } = this.props;
    const { query } = this.state;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Participantes</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Link to="/admin/participants/create" className="btn btn-success">
              Adicionar Novo
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 m-b-10">
            <Form onSubmit={e => e.preventDefault()}>
              <Form.Input
                name="query"
                placeholder="Buscar por Nome ou E-mail"
                value={query}
                onChange={this.handleChangeQuery}
              />
            </Form>
          </div>
        </div>

        <Panel>
          {!participants.data.length && participants.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {participants.loading && <Loading type="table" size="x-large" />}

              <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Idioma</th>
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {participants.data.map(participant => (
                    <tr key={String(participant.id)}>
                      <td>{participant.attributes.name}</td>
                      <td>{participant.attributes.email}</td>
                      <td>
                        {participant.attributes.locale == "en"
                          ? "Inglês"
                          : participant.attributes.locale == "pt-BR" 
                          ? "Português"
                          : "Espanhol"}
                      </td>
                      <td className="text-right">
                        <Link
                          to={`/admin/participants/${participant.id}/edit`}
                          className="btn btn-inverse btn-sm m-r-5"
                        >
                          <Icon name="pencil-alt" />
                        </Link>

                        <Button
                          className="btn btn-inverse btn-sm m-r-5"
                          onClick={() => this.handleDelete(participant.id)}
                        >
                          <Icon name="trash" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Fragment>
          )}
        </Panel>

        <Pagination
          className="m-t-20"
          current={participants.page}
          total={participants.total}
          {...this.props}
        />
      </Page>
    );
  }
}

const mapState = state => ({
  participants: {
    ...state,
    data: ParticipantsSelectors.list(state.participants.data)
  }
});

const mapActions = dispatch =>
  bindActionCreators(ParticipantsActions, dispatch);

export default connect(mapState, mapActions)(List);



// WEBPACK FOOTER //
// ./src/pages/Admin/Participants/List/index.js